import script from "./HelpCenterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpCenterPage.vue?vue&type=script&setup=true&lang=js"

import "./HelpCenterPage.vue?vue&type=style&index=0&id=305f4ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305f4ffc"]])

export default __exports__